import PageGame from '@/components/PageGame';

export default PageGame;

export async function getStaticProps() {
  return {
    props: {
      path: '/gluecksspirale/spielen/external',
      canonical: {
        path: '/gluecksspirale/spielen',
        workspace: 'website',
      },
      noindex: true,
      game: 'Gluecksspirale',
      description:
        'Ein GlücksSpirale-Los ist Ihre Chance auf 1,2 Mio. € sofort und 5.000 € monatlich, 20 Jahre lang!',
      title: 'GlücksSpirale Online-Los',
      gameGluecksspirale: 'external',
    },
  };
}
